// Faz 4 — Hakkımızda, İletişim, Proje Talep sayfaları (TR/EN).
// Form seçeneklerinde `value` daima Türkçe kalır (admin paneli/e-posta tutarlılığı için),
// yalnızca kullanıcıya gösterilen `label` çevrilir.

export const ABOUT_I18N = {
  tr: {
    seoTitle: "Dijital Roket Hakkında | Teknoloji & Dijital Dönüşüm",
    seoDesc:
      "Dijital Roket'in özel yazılım, yapay zekâ, kurumsal web ve dijital dönüşüm alanlarındaki yaklaşımını, teknoloji vizyonunu ve geliştirdiği çözümleri yakından tanıyın.",
    eyebrow: "Hakkımızda",
    title: "Dijital Roket Hakkında",
    loading: "Yükleniyor...",
    content: null, // TR içerik admin panelinden (settings.about_content) gelir
  },
  en: {
    seoTitle: "About Dijital Roket | Technology & Digital Transformation",
    seoDesc:
      "Get to know Dijital Roket's approach to custom software, artificial intelligence, corporate web and digital transformation, our technology vision and the solutions we build.",
    eyebrow: "About Us",
    title: "About Dijital Roket",
    loading: "Loading...",
    content: `## A Digital Solution Partner for Brands Since 2015

Dijital Roket is a Bursa-based technology and digital transformation company that has been building solutions since 2015 to help brands appear stronger online and work more efficiently.

Today Dijital Roket brings web design, custom software, social media, content production, AI-powered visual production, B2B systems, CRM-class panels and enterprise digital transformation projects together under one roof.

Our goal is not simply to produce good-looking work; it is to make companies' sales, operations, marketing and customer management processes faster, more measurable and more professional.

## Our Values

- Speed
- Trust
- Strategy
- Technology
- Continuous improvement
- Result orientation`,
  },
};

export const CONTACT_I18N = {
  tr: {
    seoTitle: "Dijital Roket İletişim | Projenizi Birlikte Planlayalım",
    seoDesc:
      "Web sitesi, B2B, CRM, özel yazılım veya yapay zekâ projeniz için Dijital Roket ile iletişime geçin. Bursa merkezli ekibimiz Türkiye genelinde hizmet vermektedir.",
    eyebrow: "İletişim",
    title: "Dijital Roket ile İletişime Geçin",
    subtitle: "Projenizi, ihtiyacınızı veya fikrinizi paylaşın. Dijital Roket ekibi en kısa sürede sizinle iletişime geçer.",
    infoPhone: "Telefon",
    infoEmail: "E-posta",
    infoAddress: "Adres",
    successToast: "Talebiniz alındı. En kısa sürede iletişime geçeceğiz.",
    successBox: "Talebiniz alındı. Dijital Roket ekibi en kısa sürede sizinle iletişime geçecektir.",
    labels: {
      name: "Ad Soyad",
      company: "Firma Adı",
      phone: "Telefon",
      email: "E-posta",
      projectType: "Proje Türü",
      budget: "Bütçe Aralığı",
      message: "Proje Açıklaması",
    },
    ph: {
      name: "Adınız Soyadınız",
      company: "Şirket adı",
      phone: "0 5xx xxx xx xx",
      email: "ornek@firma.com",
      message: "Projenizi, ihtiyaçlarınızı ve hedeflerinizi kısaca anlatın...",
    },
    select: "Seçiniz",
    sending: "Gönderiliyor...",
    submit: "Görüşme Talep Et",
    projectTypes: [
      "Kurumsal Web Sitesi", "B2B / Bayi Sistemi", "CRM Benzeri Sistem",
      "Satış / Teklif Paneli", "Sosyal Medya ve İçerik Üretimi", "Roket Partner Programı", "Diğer",
    ],
    budgets: ["50.000 TL altı", "50.000 - 150.000 TL", "150.000 - 500.000 TL", "500.000 TL üzeri", "Görüşmek istiyorum"],
  },
  en: {
    seoTitle: "Contact Dijital Roket | Let's Plan Your Project Together",
    seoDesc:
      "Get in touch with Dijital Roket for your website, B2B, CRM, custom software or artificial intelligence project. Our Bursa-based team serves clients across Türkiye.",
    eyebrow: "Contact",
    title: "Get in Touch with Dijital Roket",
    subtitle: "Tell us about your project, your need or your idea. The Dijital Roket team will get back to you shortly.",
    infoPhone: "Phone",
    infoEmail: "Email",
    infoAddress: "Address",
    successToast: "We've received your request. We'll be in touch shortly.",
    successBox: "We've received your request. The Dijital Roket team will contact you shortly.",
    labels: {
      name: "Full Name",
      company: "Company Name",
      phone: "Phone",
      email: "Email",
      projectType: "Project Type",
      budget: "Budget Range",
      message: "Project Description",
    },
    ph: {
      name: "Your full name",
      company: "Company name",
      phone: "+90 5xx xxx xx xx",
      email: "example@company.com",
      message: "Briefly describe your project, your needs and your goals...",
    },
    select: "Please select",
    sending: "Sending...",
    submit: "Request a Call",
    projectTypes: [
      "Corporate Website", "B2B / Dealer System", "CRM-Class System",
      "Sales / Quote Panel", "Social Media & Content Production", "Roket Partner Programme", "Other",
    ],
    budgets: ["Under ₺50,000", "₺50,000 – ₺150,000", "₺150,000 – ₺500,000", "Over ₺500,000", "I'd like to discuss"],
  },
};

export const REQUEST_I18N = {
  tr: {
    seoTitle: "Proje Talep Formu | Dijital Roket",
    seoDesc: "Detaylı proje brief'inizi paylaşın.",
    eyebrow: "Proje Talep Formu",
    title: "Detaylı Proje Brief'inizi Paylaşın",
    subtitle: "Aşağıdaki formu doldurarak projenizin kapsamını netleştirmemize yardımcı olun.",
    successToast: "Proje brief'iniz alındı. Ekibimiz inceleyip dönüş yapacak.",
    successTitle: "Talebiniz Alındı",
    successDesc: "Dijital Roket ekibi brief'inizi inceleyip en kısa sürede sizinle iletişime geçecektir.",
    sections: [
      "1. Firma Bilgileri", "2. Mevcut Dijital Durum", "3. İstenen Proje Türü", "4. Hedefler",
      "5. Kullanıcı Rolleri", "6. Gerekli Özellikler", "7. Referanslar", "8. Zaman & Bütçe", "9. Ek Notlar",
    ],
    labels: {
      company: "Firma Adı",
      contact: "İletişim Kişisi",
      email: "E-posta",
      phone: "Telefon",
      current: "Şu an kullandığınız sistemler, web sitesi durumu, mevcut süreçler",
      type: "Proje türü",
      goals: "Bu projeyle ulaşmak istediğiniz hedefler",
      roles: "Sistemde kimler bulunacak? (Admin, satış ekibi, bayi, müşteri vb.)",
      features: "Olmazsa olmaz özellikler ve modüller",
      refs: "Örnek aldığınız siteler / sistemler",
      timeline: "Zaman beklentisi",
      budget: "Bütçe aralığı",
      notes: "Eklemek istediğiniz başka bir şey",
    },
    select: "Seçiniz",
    sending: "Gönderiliyor...",
    submit: "Brief'i Gönder",
    projectTypes: [
      "Kurumsal Web Sitesi", "B2B / Bayi Sistemi", "CRM Benzeri Sistem", "Satış / Teklif Paneli",
      "Yönetici Dashboard", "Sosyal Medya ve İçerik Üretimi", "Özel Panel ve Otomasyon", "Roket Partner Programı", "Diğer",
    ],
    budgets: ["50.000 TL altı", "50.000 - 150.000 TL", "150.000 - 500.000 TL", "500.000 TL üzeri", "Görüşmek istiyorum"],
    timelines: ["Acil (1-2 hafta)", "1 ay içinde", "1-3 ay", "3+ ay", "Esnek"],
  },
  en: {
    seoTitle: "Project Request Form | Dijital Roket",
    seoDesc: "Share your detailed project brief with us.",
    eyebrow: "Project Request Form",
    title: "Share Your Detailed Project Brief",
    subtitle: "Fill in the form below to help us clarify the scope of your project.",
    successToast: "We've received your project brief. Our team will review it and get back to you.",
    successTitle: "Request Received",
    successDesc: "The Dijital Roket team will review your brief and contact you shortly.",
    sections: [
      "1. Company Details", "2. Current Digital Setup", "3. Requested Project Type", "4. Goals",
      "5. User Roles", "6. Required Features", "7. References", "8. Timeline & Budget", "9. Additional Notes",
    ],
    labels: {
      company: "Company Name",
      contact: "Contact Person",
      email: "Email",
      phone: "Phone",
      current: "The systems you use today, the state of your website, current processes",
      type: "Project type",
      goals: "The goals you want to reach with this project",
      roles: "Who will use the system? (Admin, sales team, dealers, customers, etc.)",
      features: "Must-have features and modules",
      refs: "Sites / systems you see as references",
      timeline: "Expected timeline",
      budget: "Budget range",
      notes: "Anything else you'd like to add",
    },
    select: "Please select",
    sending: "Sending...",
    submit: "Send the Brief",
    projectTypes: [
      "Corporate Website", "B2B / Dealer System", "CRM-Class System", "Sales / Quote Panel",
      "Executive Dashboard", "Social Media & Content Production", "Custom Panel & Automation", "Roket Partner Programme", "Other",
    ],
    budgets: ["Under ₺50,000", "₺50,000 – ₺150,000", "₺150,000 – ₺500,000", "Over ₺500,000", "I'd like to discuss"],
    timelines: ["Urgent (1–2 weeks)", "Within a month", "1–3 months", "3+ months", "Flexible"],
  },
};
